import React from 'react';

const KeyTopics = ({ topics }) => {
  return (
    <div className="mt-7">
      <p className="text-[17px] font-bold text-black mb-7">Key Topics:</p>
      <div className="flex flex-col gap-7">
        {topics.map((topic, index) => (
          <p key={index} className="text-[17px] leading-[1.85] text-black">
            <span className="text-gray-400 mr-2">→</span>
            {topic.title} - {topic.description}
          </p>
        ))}
      </div>
    </div>
  );
};

export default KeyTopics;
